const DENKER_ALIASES = [
  "denker",
  "denka",
  "danker",
  "dinker",
  "anchor",
  "tinker",
  "thinker",
];

const DENKER_ALIAS_PATTERN = DENKER_ALIASES.join("|");
const DENKER_ALIAS_SET = new Set(DENKER_ALIASES);
const LEADING_DENKER_RE = new RegExp(
  `^\\s*(?:hey\\s+|okay\\s+|ok\\s+)?(?:${DENKER_ALIAS_PATTERN})[\\s,.:-]+`,
  "i",
);
const MENTION_DENKER_RE = new RegExp(
  `(?<=\\s|^)@(${DENKER_ALIAS_PATTERN})(?=\\s|$)`,
  "gi",
);

export type DenkerModeCommandTarget = "denk" | "workspace" | "compact";

export function normalizeDenkerMentions(
  text: string,
  agentNames: string[],
): string {
  const denkerName = agentNames.find((name) => name.toLowerCase() === "denker");
  if (!denkerName) return text;
  const realAgentNames = new Set(agentNames.map((name) => name.toLowerCase()));
  return text.replace(MENTION_DENKER_RE, (match, alias: string) => {
    const lowerAlias = alias.toLowerCase();
    if (lowerAlias !== "denker" && realAgentNames.has(lowerAlias)) {
      return match;
    }
    return DENKER_ALIAS_SET.has(lowerAlias) ? `@${denkerName}` : match;
  });
}

export function parseDenkerModeCommand(
  text: string,
): DenkerModeCommandTarget | null {
  const command = text.replace(LEADING_DENKER_RE, "").trim().toLowerCase();
  if (command === text.trim().toLowerCase()) return null;

  const asksForMode =
    /\b(mode|view|workspace|overlay|window)\b/.test(command) &&
    /\b(toggle|switch|set|change|open|enter|go|turn|close|exit|hide)\b/.test(
      command,
    );
  if (!asksForMode) return null;

  if (/\b(compact|closed|close|exit|hide|off)\b/.test(command)) {
    return "compact";
  }
  if (/\b(workspace|space)\b/.test(command)) {
    return "workspace";
  }
  if (/\b(denk|dank|danker|denker|think|thinking)\b/.test(command)) {
    return "denk";
  }
  return null;
}
